// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fuxa-view-dialog {
  position: relative;
}
.fuxa-view-dialog .dialog-modal-close {
  top: 0px;
  right: 0px;
  height: 22px;
  width: 100%;
  color: rgba(0, 0, 0, 0.7);
  font-size: 12px;
}
.fuxa-view-dialog .dialog-modal-close i {
  float: right;
}`, "",{"version":3,"sources":["webpack://./src/app/fuxa-view/fuxa-view-dialog/fuxa-view-dialog.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/fuxa-view/fuxa-view-dialog/fuxa-view-dialog.component.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;ACAJ;ADCI;EAEI,QAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EAEA,eAAA;ACDR;ADIQ;EACI,YAAA;ACFZ","sourcesContent":["\n.fuxa-view-dialog {\n    position: relative;\n    .dialog-modal-close {\n        //position: absolute;\n        top: 0px;\n        right: 0px;\n        height: 22px;\n        width: 100%;\n        color: rgba(0, 0, 0, 0.7);\n        // background-color: transparent;\n        font-size: 12px;\n        // cursor: move !important;\n\n        i {\n            float: right;\n        }\n    }\n}\n",".fuxa-view-dialog {\n  position: relative;\n}\n.fuxa-view-dialog .dialog-modal-close {\n  top: 0px;\n  right: 0px;\n  height: 22px;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.7);\n  font-size: 12px;\n}\n.fuxa-view-dialog .dialog-modal-close i {\n  float: right;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
